export function sortByStartsWith(startsWithInput, labelAttribute, identifierAttribute) {
    const inputLower = startsWithInput.toLowerCase();
    return (a, b) => {
        if (a[identifierAttribute] === inputLower) {
            return -1;
        }
        if (b[identifierAttribute] === inputLower) {
            return 1;
        }
        const aLabelLower = a[labelAttribute].toLowerCase();
        const bLabelLower = b[labelAttribute].toLowerCase();
        if (aLabelLower.startsWith(inputLower) &&
            !bLabelLower.startsWith(inputLower)) {
            return -1;
        }
        if (!aLabelLower.startsWith(inputLower) &&
            bLabelLower.startsWith(inputLower)) {
            return 1;
        }
        return 0;
    };
}
//# sourceMappingURL=sort-by-starts-with.js.map